import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/81164d3ba0f00c2a7e247a9f180c9b75/de152bcca179c84c1b093f52431caded.png"
              alt="Robin J. Peterson Company, LLC"
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-teal-600"
            >
              Home
            </Link>
          </div>

          <a
            href="tel:2166429007"
            className="hidden lg:flex items-center px-6 py-3 bg-gray-900 text-white rounded-full text-sm font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            216-642-9007
          </a>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-gray-900"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            <Link to="/" className="block text-sm font-medium text-gray-700 hover:text-teal-600 py-2">Home</Link>
            <a
              href="tel:2166429007"
              className="flex items-center justify-center px-6 py-3 bg-gray-900 text-white rounded-full text-sm font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap mt-4"
            >
              <i className="ri-phone-line mr-2"></i>
              216-642-9007
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
